export default "__VITE_ASSET__CZk2GTVl__"